import React, { useState } from "react";
import styled, { withTheme } from "styled-components";
import { H5 } from "../../Typography";
import SmallLink from "./SmallLink";
import LinkArrow from "./LinkArrow";

import theme from "../../../styles/theme";

const StyledDiv = styled.div`
  display: flex;
  margin-bottom: 40px;
  ${() => theme.media.desktopUp`
    display: block;
    margin-right: 120px;
    margin-bottom: 16px;
    min-width: 280px;
    max-width: 280px;
    color: ${() => theme.colors.green5};
  `};
`;

const PromoImgWrapper = styled.div`
  ${() => theme.media.tabletDown`
    overflow: hidden;
    border-radius: 16px;
    width: 120px;
    height: 120px;
    flex-shrink: 0;
    margin-right: 24px;
  `};
`

const PromoImg = styled.img`
  display: block;
  max-width: none;
  width: 110%;
  height: 110%;
  object-fit: cover;
  object-position: left center;
  ${() => theme.media.desktopUp`
    width: 100%;
    height: auto;
    margin-bottom: 16px;
  `};
`;

const Heading = styled(H5)`
  color: ${() => theme.colors.green5};
  margin-top: 0;
  margin-bottom: 16px;
  `;
  
const StyledSmallLink = styled(SmallLink)`
  display: flex;
  line-height: 120%;
  margin-bottom: 16px;
`;

const ArrowWrapper = styled.span`
  padding-left: 24px;
`;

const PromoCard = ({ image, heading, link, secondaryLink }) => {
  const [active, setActive] = useState(false);
  return (
    <StyledDiv>
      <PromoImgWrapper><PromoImg src={image.asset} alt={heading} /></PromoImgWrapper>
      <div
        onMouseEnter={() => setActive(true)}
        onMouseLeave={() => setActive(false)}
      >
        <Heading>{heading}</Heading>
        <StyledSmallLink href={link[0].url}>
          {link[0].label}
          <ArrowWrapper>
            <LinkArrow
              right
              fillColor={active ? theme.colors.green3 : theme.colors.green5}
              animate={active && "shiftRight"}
            />
          </ArrowWrapper>
        </StyledSmallLink>
        {secondaryLink && secondaryLink[0] && 
        <StyledSmallLink href={secondaryLink[0].url}>
          {secondaryLink[0].label}
          <ArrowWrapper>
            <LinkArrow
              right
              fillColor={active ? theme.colors.green3 : theme.colors.green5}
              animate={active && "shiftRight"}
            />
          </ArrowWrapper>
        </StyledSmallLink>
        }
      </div>
    </StyledDiv>
  );
};

export default withTheme(PromoCard);
